import * as _ from 'lodash';
import * as api from './../../api/api.service';
import * as featuresApi from './../../api/features.service';
import * as offersApi from './../../api/offers.service';
import * as rfpsApi from './../../api/rfps/rfp.service';
import { IAptAttachment } from '../../core/layout/fileUpload/aptFileAttachments.service';

class OfferImpactForSellerCtrl {
  attachments: IAptAttachment[];

  rfpId;

  /**
   * The logged in user
   *
   * @type {account}
   */
  account;

  /**
   * The current rfp (based on the route)
   *
   * @type {rfpsApi.RfpVersionTwo}
   */
  rfp: rfpsApi.RfpVersionTwo;

  featureList: featuresApi.FeatureFlags;

  totalParticipantsCount;
  participants;

  selectedOffer;
  offers;

  // Reload this to reflect selected data set (there's only one on seller side)
  pucks;

  // Tier dropdown
  selectedTier; // was targetMarketShare / scenario.marketShare
  isLoadingScenario = false; // was cantRunScenario

  usePrimaryEquivalentCrosses = true;

  // The data for the group as a whole
  microChartData: offersApi.MicroChart;

  overview;

  // TODO: Reload offers if user submits the response

  constructor(
    private api: api.IApiService,
    private LoadingIndicator,
    private $q,
    private OfferImpactService,
    private $location,
  ) {
    'ngInject';

    this.overview = this.OfferImpactService.getOverviewData();
  }

  /**
   * This loads the account, rfp, and other data
   */
  $onInit() {
    let accountLoader = this.api.users
      .currentUser()
      .then((account) => (this.account = account));
    let rfpLoader = this.api.rfps
      .getRfp(this.rfpId)
      .then((rfp: any) => (this.rfp = rfp));
    let featureLoader = this.api.features
      .getFeatures()
      .then((features) => (this.featureList = features));
    let participantsLoader = this.OfferImpactService.loadParticipants(
      this.rfpId,
    ).then((participants) => (this.participants = participants));

    this.api.rfps.getAttachments(this.rfpId).then((attachments) => {
      this.attachments = attachments;
    });

    this.LoadingIndicator.waitFor(accountLoader);
    this.LoadingIndicator.waitFor(rfpLoader);
    this.LoadingIndicator.waitFor(featureLoader);

    this.$q.all([accountLoader, rfpLoader, featureLoader]).then(() => {
      // Might be able to just call this /sellers/{sellerId}/offers (lighter weight)
      let offersLoader = this.api.rfps
        .loadOffers(this.rfp.id, this.account.organization.id)
        .then((offers) => {
          this.offers = offers?.filter(
            (offer: any) => offer.productPricingStatus === 'COMPLETE',
          );


          if (this.offers.length == 0) {
            // TODO: Redirect back to the Overview page (or structure?) since this page needs an offer
            // console.log('Somehow got to this page with no offers, so sending back to structure page');

            this.$location.replace();
            this.$location.path('/structure/' + this.rfpId);
          }

          // Set the default selected offer and tier
          let selectedOffer = this.getDefaultSelectedOffer(this.offers) as any;
          this.setSelectedOffer(selectedOffer.id);
          // this.setDefaultTierForOffer(this.selectedOffer);
        });
    });

    this.$q
      .all([accountLoader, rfpLoader, featureLoader, participantsLoader])
      .then(() => {
        this.totalParticipantsCount = this.participants.totalCount;

        this.pucks = this.OfferImpactService.getParticipantPucks(
          this.participants,
        );
      });
  }

  /**
   * This used to be runScenario (in reload data mode)
   *
   */
  loadScenario(usePrimaryEquivalentCrosses) {
    var allPromises: any[] = [];

    this.usePrimaryEquivalentCrosses = usePrimaryEquivalentCrosses;

    // Load the group data
    allPromises.push(this.loadGroupData());

    return this.$q.all(allPromises);
  }

  /**
   * This used to be runScenario (in use existing data mode)
   * @param {[type]} $event [description]
   */
  updateScenario($event) {
    // console.log('Inside updateScenario($event)');
    // console.log('Updating scenario without loading data...');
    // console.log($event);

    if ($event.selectedTier) {
      this.selectedTier = $event.selectedTier;
    }

    this.overview.dials.abilityToReachTarget.label =
      this.OfferImpactService.getMicroChartLabel(
        this.selectedTier.dollarMarketShare,
      );
  }

  loadGroupData() {
    let loader = this.OfferImpactService.loadMicroChartData(
      this.selectedOffer.id,
      this.rfp.buyer.id,
      this.usePrimaryEquivalentCrosses,
    );

    loader.then((microchartData) => {
      this.microChartData = microchartData;

      this.overview.dials.abilityToReachTarget.label =
        this.OfferImpactService.getMicroChartLabel(
          this.selectedTier.dollarMarketShare,
        );
    });

    return loader;
  }

  getDefaultSelectedOffer(offers) {
    if (offers.length) {
      let sortedOffers = _.sortBy(offers, 'createdDate');
      return sortedOffers[0];
    } else {
      return null;
    }
  }

  setSelectedOffer(offerId) {
    if (this.offers) {
      this.selectedOffer = _.find(this.offers, {
        id: offerId,
      });

      this.setDefaultTierForOffer(this.selectedOffer);

      this.loadScenario(this.usePrimaryEquivalentCrosses);
    }
  }

  setDefaultTierForOffer(offer) {
    let sortedTiers = _.sortBy(this.selectedOffer.tiers, 'order');

    this.selectedTier = sortedTiers[0];
  }
}

export const OfferImpactForSellerComponent = {
  template: require('./offerImpactForSeller.component.html'),
  controller: OfferImpactForSellerCtrl,
  bindings: {
    rfpId: '<',
  },
};
